import React, { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { LabledMultilineTextField } from "../core/LabledMultilineTextField";

export const IncreaseAdditionalNotesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.INCREASE_ADDITIONAL_NOTES>();
    return (
        <Fragment>
            <div className={classes.additionalInfoTitle}>Begründung</div>
            <LabledMultilineTextField
                placeholder="Bitte beschreiben Sie kurz den Grund für die gewünschte Leistungserhöhung."
                margin="none"
                inputProps={{
                    maxLength: 1000,
                }}
                value={values.increaseAdditionalNotes.value.text || ""}
                onChange={(event) => {
                    setValues((values) => {
                        values.increaseAdditionalNotes.value.text = event.target.value || "";
                    });
                }}
                error={values.increaseAdditionalNotes.error !== null}
            />
        </Fragment>
    );
};
